import { Config } from '@/config/types';

const qaConfig: Config = {
  configType: 'qa',
  apiRoot: 'https://7ajq1kzbn2.execute-api.ap-southeast-1.amazonaws.com',
  apiEmailRoot: 'https://nocci-api.f5w.app',
};

export default qaConfig;
